import Recuperar from '../views/Recuperar.vue'
import cambiarPass from '../views/changePass.vue'
const routes = [
    {
        path: '/inicio',
        name: 'inicio',
        component: () => import('../views/Inicio.vue'),
        meta: { requiresAuth: true },

    },
    {
        path: '/liquidaciones',
        name: 'liquidaciones',
        component: () => import('../views/liquidaciones.vue'),
        meta: { requiresAuth: true },

    },
    {
        path: '/palabra-clave',
        name: 'palabraClave',
        props: true,
        component: () => import('../components/modales/Avisos.vue'),
        
    },
    {
        path: '/novedades/aviso/:id',
        name: 'aviso',
        props: true,
        component: () => import('../views/aviso.vue'),
        meta: { requiresAuth: true },
    },
    //ADMINISTRACONinvitacion
    {
        path: '/',
        name: 'login',
        props: true,
        component: () => import('../views/login.vue'),
        
    },
    {
        path: '/pedidos',
        name: 'Pedidos',
        props: true,
        component: () => import('../views/Pedidos.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/envio-a-domicilio',
        name: 'Domicilio',
        props: true,
        component: () => import('../views/Domicilio.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/contacto',
        name: 'contacto',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('../views/contacto.vue')
        
    },
    {
        path: '/ayuda',
        name: 'faqs',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('../views/ayuda.vue')

    },
    {
        path: '/error/:error',
        name: 'error',
        props: true,
        component: () => import('../views/errores/error.vue')
    },
    {
        path: '/recuperar',
        name: 'recuperar',
        component: Recuperar,
    },
    {
        path: '/cambiarPass',
        name: 'cambiarPass',
        props: route => ({ query: route.query.s }),
        component: cambiarPass
    },

]

export default routes